Postlogin = (function (self) {
    self.LessonsList = {};
    const me = self.LessonsList;

    const $lessonsListTable = $('#lessons-list-table');
    const initBootstrapTable = function () {
        const columns = [
            {
                title: 'Image',
                field: 'lesson_image',
                align: 'center',
                valign: 'middle',
                sortable: false,
                formatter(value, row) {
                    const assignmentsListUrl = $lessonsListTable.data('assignments-list-url').replace(':lesson_id', row.lesson_id);

                    return `<a href="${assignmentsListUrl}"><img src="${value}" style="width: 140px; height: 105px;"/></a>`;
                },
            },
            {
                title: 'Name / Cluster',
                field: 'name',
                align: 'center',
                valign: 'middle',
                sortable: true,
                formatter(value, row) {
                    const assignmentsListUrl = $lessonsListTable.data('assignments-list-url').replace(':lesson_id', row.lesson_id);

                    return `<a href="${assignmentsListUrl}">${value}</a>`;
                },
            },
            {
                title: 'Grades',
                field: 'grade_band',
                align: 'left',
                valign: 'middle',
                sortable: true,
            },
            {
                title: 'Length',
                field: 'total_time_seconds',
                align: 'left',
                valign: 'middle',
                sortable: true,
                formatter(value) {
                    const duration = moment.duration(value * 1000); // convert seconds to milliseconds

                    return `<span title="${duration.asMinutes()} minutes">${duration.humanize()}</span>`;
                },
            },
            {
                title: 'Assignments',
                field: 'assignment_count',
                align: 'left',
                valign: 'middle',
                sortable: true,
                class: 'assignment-column',
                formatter(value, row) {
                    const assignmentsListUrl = $lessonsListTable.data('assignments-list-url').replace(':lesson_id', row.lesson_id);
                    const timesAssigned = value !== 1 ? `${value} assignments` : `${value} assignment`;

                    return `<a href="${assignmentsListUrl}" class="btn btn-hollow-dark-gray">${timesAssigned}</a>`;
                },
            },
            {
                title: 'Lesson Resources',
                field: 'document',
                align: 'center',
                valign: 'middle',
                sortable: false,
                class: 'documents-column',
                formatter(value, row, index) {
                    if (!value || row.can_assign === 0) {
                        return null;
                    }

                    const documents = `
                        <div class="dropdown">
                            <a class="btn btn-default dropdown-toggle" type="button" href="#"
                                id="documents-dropdown-${index}" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                Docs
                                <span class="caret"></span>
                            </a>
                            <ul class="dropdown-menu dropdown-menu-right" aria-labelledby="documents-dropdown-${index}">
                                ${value
                        .map(
                            (document) => `
                                    <li>
                                        <a target="_blank" href="${document.document_path}" type="button" class="document-download-btn">${document.title}</a></li>
                                `,
                        )
                        .join('')}
                            </ul>
                            </div>`;

                    return documents;
                },
            },
            {
                title: 'Actions',
                field: 'actions',
                align: 'center',
                valign: 'middle',
                sortable: false,
                formatter(value, row) {
                    if (+row.can_assign === 1) {
                        const assignmentsAddUrl = $lessonsListTable.attr('data-assignments-add-url').replace(':lesson_id', row.lesson_id);
                        const lessonPreviewUrl = $lessonsListTable.attr('data-lesson-preview-url').replace(':lesson_guid', row.guid);

                        return `
                            <a href="${lessonPreviewUrl}" class="btn btn-hollow-green" target="_blank">Preview</a>
                            <a href="${assignmentsAddUrl}" class="btn btn-hollow-blue">Assign</a>
                        `;
                    }

                    if (+row.can_assign === 0) {
                        return `
                            <button class="btn btn-green lesson-disabled-inquiry">Inquire <i class="fa fa-question-circle"
                                aria-hidden="true"></i></button>
                        `;
                    }

                    return '';
                },
            },
        ];

        $lessonsListTable.bootstrapTable({
            formatNoMatches() {
                return 'No lessons to show';
            },
            classes: 'table table-hover table-condensed',
            striped: true,
            showRefresh: false,
            showToggle: false,
            showColumns: false,
            showPaginationSwitch: false,
            idField: 'lesson_id',
            minimumCountColumns: '2',
            pagination: false,
            search: true,
            sortName: 'name',
            sortOrder: 'asc',
            toolbar: '#report-toolbar',
            toolbarAlign: 'right',
            searchAlign: 'left',
            clickToSelect: false,
            maintainSelected: false,
            sidePagination: 'server',
            url: '/lessons/json/',
            pageSize: 26,
            queryParamsType: 'other',
            queryParams(params) {
                const tableParams = {};

                tableParams.search_term = params.searchText;
                tableParams.page = params.pageNumber;
                tableParams.page_size = params.pageSize;
                tableParams.order_by = params.sortName;
                tableParams.sort_order = params.sortOrder;

                tableParams.published = 1;

                return tableParams;
            },
            columns,
            responseHandler(res) {
                const formattedResult = {};
                formattedResult.total = res.meta.total;
                formattedResult.rows = res.data;

                return formattedResult;
            },
            onLoadSuccess() {
                $('time.timeago').timeago();
            },
            onPostBody() {
                $('.lesson-disabled-inquiry').on('click', () => {
                    VjsUtility.Popup.init({
                        iconType: 'fa',
                        // transition: 'slide-top',
                        bodyClasses: 'no-title',
                        hideTitle: true,
                        content: `This lesson is not available with your current subscription.
                            If you are interested in upgrading your subscription, please reach out to your account manager.`,
                    });
                });
            },
            rowStyle(row) {
                let classes = '';

                if (+row.can_assign === 0) {
                    classes += 'lesson-disabled';
                }

                return {
                    classes,
                };
            },
        });
    };

    me.init = function () {
        initBootstrapTable();
    };

    return self;
}(Postlogin || {}));
